module.exports = __webpack_public_path__ + "static/media/neverdie.ab21afbb.svg";